/** @format */

import {Trans} from 'react-i18next';

export const BREADCRUMBS = [
  {
    href: '/home/settings',
    title: <Trans>Настройки</Trans>,
  },
  {
    href: '',
    title: <Trans>Настройки тарифа</Trans>,
  },
];
